import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../ServicePage.css';

function EcommerceSolutions() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">E-commerce Solutions</h1>
                    <p className="service-description">
                        Sviluppo completo di piattaforme e-commerce con Magento 2, OpenMage, WooCommerce. 
                        Specializzato in migrazione, moduli custom e integrazione con Odoo ERP.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">Piattaforme E-commerce Supportate</h2>
                                
                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <div className="platform-item">
                                            <div className="platform-icon">
                                                <i className="fab fa-magento text-primary"></i>
                                            </div>
                                            <h4>Magento 2</h4>
                                            <p>
                                                Sviluppo e personalizzazione su Magento 2, la piattaforma e-commerce enterprise 
                                                più potente per negozi di medio-grandi dimensioni con funzionalità avanzate.
                                            </p>
                                            <ul className="platform-features">
                                                <li>Setup e configurazione completa</li>
                                                <li>Temi custom e responsive design</li>
                                                <li>Moduli personalizzati</li>
                                                <li>Performance optimization</li>
                                                <li>Multi-store e multi-lingua</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="platform-item">
                                            <div className="platform-icon">
                                                <i className="fas fa-code text-primary"></i>
                                            </div>
                                            <h4>Magento 1 / OpenMage</h4>
                                            <p>
                                                Supporto completo per Magento 1 e migrazione a OpenMage (fork community-driven) 
                                                per mantenere in vita i vecchi store con sicurezza e performance aggiornate.
                                            </p>
                                            <ul className="platform-features">
                                                <li>Manutenzione Magento 1.9</li>
                                                <li>Migrazione a OpenMage</li>
                                                <li>Patch di sicurezza</li>
                                                <li>Estensioni personalizzate</li>
                                                <li>Ottimizzazione performance</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="platform-item">
                                            <div className="platform-icon">
                                                <i className="fab fa-wordpress text-primary"></i>
                                            </div>
                                            <h4>WooCommerce</h4>
                                            <p>
                                                Sviluppo negozi WooCommerce per WordPress, ideale per piccole-medie aziende 
                                                che vogliono una soluzione flessibile e facile da gestire.
                                            </p>
                                            <ul className="platform-features">
                                                <li>Setup WooCommerce completo</li>
                                                <li>Plugin custom development</li>
                                                <li>Integrazione gateway pagamento</li>
                                                <li>Ottimizzazione SEO</li>
                                                <li>Assistenza e manutenzione</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="platform-item">
                                            <div className="platform-icon">
                                                <i className="fas fa-exchange-alt text-primary"></i>
                                            </div>
                                            <h4>Migrazione Magento</h4>
                                            <p>
                                                <strong>Specializzato nella migrazione da Magento 1.9 a OpenMage</strong> 
                                                mantenendo tutti i dati, customizzazioni e garantendo continuità del business.
                                            </p>
                                            <ul className="platform-features">
                                                <li>Migrazione dati completa</li>
                                                <li>Preservazione customizzazioni</li>
                                                <li>Test approfonditi</li>
                                                <li>Backup e rollback plan</li>
                                                <li>Formazione del team</li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Sviluppo Moduli Custom</h2>
                                
                                <p className="section-description">
                                    Creo moduli e plugin personalizzati per estendere le funzionalità delle piattaforme e-commerce 
                                    secondo le specifiche esigenze del tuo business.
                                </p>

                                <Row>
                                    <Col md={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-puzzle-piece text-primary"></i>
                                            </div>
                                            <h5>Moduli Magento Custom</h5>
                                            <ul>
                                                <li>Gestione prodotti avanzata</li>
                                                <li>Sistemi di sconti personalizzati</li>
                                                <li>Integrazioni ERP/CRM</li>
                                                <li>Workflow di ordini custom</li>
                                                <li>Report e analytics avanzati</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col md={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-plug text-primary"></i>
                                            </div>
                                            <h5>Plugin WooCommerce</h5>
                                            <ul>
                                                <li>Sistemi di membership</li>
                                                <li>Booking e prenotazioni</li>
                                                <li>Configuratori prodotto</li>
                                                <li>Integrazioni terze parti</li>
                                                <li>Automazioni marketing</li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">🎯 Integrazione con Odoo ERP</h2>
                                
                                <p className="section-description">
                                    <strong>Specializzazione nell'integrazione di e-commerce con Odoo</strong> per unificare 
                                    gestione vendite, magazzino, contabilità e CRM in un'unica piattaforma.
                                </p>

                                <Row>
                                    <Col lg={4} className="mb-4">
                                        <div className="integration-item">
                                            <div className="integration-icon">
                                                <i className="fas fa-sync text-primary"></i>
                                            </div>
                                            <h5>Sincronizzazione Dati</h5>
                                            <ul>
                                                <li>Prodotti e categorie</li>
                                                <li>Clienti e contatti</li>
                                                <li>Ordini e fatturazione</li>
                                                <li>Magazzino e stock</li>
                                                <li>Prezzi e listini</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={4} className="mb-4">
                                        <div className="integration-item">
                                            <div className="integration-icon">
                                                <i className="fas fa-warehouse text-primary"></i>
                                            </div>
                                            <h5>Gestione Magazzino</h5>
                                            <ul>
                                                <li>Stock in tempo reale</li>
                                                <li>Movimenti automatici</li>
                                                <li>Multi-magazzino</li>
                                                <li>Picking e shipping</li>
                                                <li>Inventario centralizzato</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={4} className="mb-4">
                                        <div className="integration-item">
                                            <div className="integration-icon">
                                                <i className="fas fa-chart-line text-primary"></i>
                                            </div>
                                            <h5>Business Intelligence</h5>
                                            <ul>
                                                <li>Report vendite unificati</li>
                                                <li>Analytics performance</li>
                                                <li>KPI dashboard</li>
                                                <li>Previsioni vendita</li>
                                                <li>ROI e marginalità</li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Servizi di Assistenza E-commerce</h2>
                                
                                <Row>
                                    <Col md={4} className="mb-4">
                                        <div className="assistance-item">
                                            <div className="assistance-icon">
                                                <i className="fas fa-tools text-primary"></i>
                                            </div>
                                            <h5>Manutenzione</h5>
                                            <ul>
                                                <li>Aggiornamenti sicurezza</li>
                                                <li>Backup automatici</li>
                                                <li>Monitoraggio performance</li>
                                                <li>Pulizia database</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="mb-4">
                                        <div className="assistance-item">
                                            <div className="assistance-icon">
                                                <i className="fas fa-headset text-primary"></i>
                                            </div>
                                            <h5>Supporto Tecnico</h5>
                                            <ul>
                                                <li>Assistenza telefonica</li>
                                                <li>Supporto remoto</li>
                                                <li>Risoluzione bug</li>
                                                <li>Formazione utenti</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="mb-4">
                                        <div className="assistance-item">
                                            <div className="assistance-icon">
                                                <i className="fas fa-rocket text-primary"></i>
                                            </div>
                                            <h5>Ottimizzazione</h5>
                                            <ul>
                                                <li>Performance tuning</li>
                                                <li>SEO e conversioni</li>
                                                <li>UX improvements</li>
                                                <li>A/B testing</li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card className="service-card cta-card">
                            <Card.Body className="text-center">
                                <h3>Pronto a Far Crescere il Tuo E-commerce?</h3>
                                <p className="mb-4">
                                    Contattaci per una consulenza gratuita sul tuo progetto e-commerce. 
                                    Analizzeremo le tue esigenze e ti proporremo la soluzione migliore.
                                </p>
                                <a href="#contact" className="btn btn-primary btn-lg">
                                    Richiedi Consulenza Gratuita
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default EcommerceSolutions;